import "./checkBox.css";
import DoneIcon from "../../../picture/doneIconGreen.png";

const Checkbox = ({
  label,
  value,
  setChecked,
  checked,
  index,
  fromDataEntry,
}) => {
  console.log(fromDataEntry);

  const handleDataOnClick = () => {
    let newObject;
    console.log(fromDataEntry, checked);
    if (fromDataEntry) {
      newObject = checked.map((item, i) => {
        console.log(index, i);
        if (index === i) {
          return !item;
        } else return item;
      });
    } else {
      newObject = !checked;
    }
    console.log(newObject);
    setChecked(newObject);
  };
  console.log(checked, fromDataEntry);
  console.log(index);
  return (
    <>
      <div className="checkbox-input" onClick={() => handleDataOnClick()}>
        {fromDataEntry
          ? checked !== undefined &&
            checked[index] && (
              <img className="checkbox-input-icon " src={DoneIcon} />
            )
          : checked && <img className="checkbox-input-icon " src={DoneIcon} />}
      </div>
      <label className="checkbox-name">{label}</label>{" "}
    </>
  );
};

export default Checkbox;
